import { useContext } from 'react';
import { TeamContext } from '../contexts/teamContextStore';

export const useTeam = () => {
  const ctx = useContext(TeamContext);
  if (!ctx) {
    return {
      ownedTeam: null,
      memberTeams: [],
      userTeams: [],
      currentTeam: null,
      activeTeamId: null,
      setActiveTeamId: () => {},
      loading: false,
      refreshTeamContext: async () => {},
      reconcileActiveTeam: () => {},
    };
  }
  return ctx;
};
